import { DIALOG_DATA } from '@angular/cdk/dialog';
import {
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  Optional,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/app.constants';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { SearchByVehicleService } from 'src/_lib/service/search-by-vehicle.service';
import { NgIf, NgFor, KeyValuePipe, NgClass, KeyValue } from '@angular/common';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ClickOutsiteDirective } from 'src/_lib/directive/click-outsite.directive';
import { SortByValuePipe } from 'src/_lib/pipes/keyvaluenosort';
import { environment } from 'src/environments/environment.prod';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-search-by-vehicle',
  templateUrl: './search-by-vehicle.component.html',
  styleUrls: [
    './search-by-vehicle.component.scss',
    './search-by-vehicle-ch4.component.scss',
  ],
  standalone: true,
  imports: [
    ClickOutsiteDirective,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    NgClass,
    NgxIntlTelInputModule,
    NgIf,
    NgFor,
    KeyValuePipe,
    SortByValuePipe,
  ],
  encapsulation: ViewEncapsulation.None,
  host: { 'ngSkipHydration': 'true' }
})
export class SearchByVehicleComponent implements OnInit {
  chTheme4 = environment.chTheme4;
  chTheme3 = environment.chTheme3;
  chTheme12 = environment.chTheme12;
  chTheme13 = environment.chTheme13;
  chTheme14 = environment.chTheme14;
  chTheme15 = environment.chTheme15;
  
  firstObj: number = this.appConstants.firstObj;
  commonImagePath: string = environment.commonImagePath;
  imgBasePath: string = environment.imageBasePath;
  initialData: { [key: string]: string } = {};
  vehicleName: string = '';
  mmyDataExists: boolean = false;
  mmyDropDownData = {
    product_key: '',
    select_make: '',
    select_model: '',
    select_year: '',
    sub_model_1: '',
    sub_model_2: '',
    sub_model_3: '',
    category: '',
  };
  withoutCategorySearch: boolean = false;
  mmysubCategoriesDropDownData: any[];

  makes: { [key: string]: string } = {};
  selectedMakeKey: string = '';
  isMakeSelected: boolean = false;
  disableMake: boolean = false;

  models: { [key: string]: string } = {};
  selectedModelKey: string = '';
  isModelSelected: boolean = false;
  disableModel: boolean = true;

  years: { [key: string]: string } = {};
  selectedYearKey: string = '';
  isYearSelected: boolean = false;
  disableYear: boolean = true;

  submodels1: { [key: string]: string } = {};
  selectedSubmodel1Key: string = '';
  showSubmodel1: boolean = false;
  isSubmodel1selected: boolean = false;
  disableSubmodel1: boolean = false;

  submodels2: { [key: string]: string } = {};
  selectedSubmodel2Key: string = '';
  showSubmodel2: boolean = false;
  isSubmodel2selected: boolean = false;
  disableSubmodel2: boolean = false;

  submodels3: { [key: string]: string } = {};
  selectedSubmodel3Key: string = '';
  showSubmodel3: boolean = false;
  isSubmodel3selected: boolean = false;
  disableSubmodel3: boolean = false;

  showCategory: boolean = false;
  lastSubCategory: any;
  disableSearchAgain: boolean = true;
  showSearchAgain: boolean = false;
  firstClickedOutside: boolean = true;
  homeSettings: any;
  showFeaturedLogo: any;
  isloading: boolean = false;
  vehicalsearchdata: any;
  MakeData: any;
  ModelData: any;
  YearData: any;
  Submodels1Data: any;
  Submodels2Data: any;
  Submodels3Data: any;
  dropDownData: any;
  getMakeData: any;
  getModelData: any;
  getYearsData: any;
  getSubModel1Data: any;
  getSubModel2Data: any;
  getSubModel3Data: any;
  makepopdata: any;
  makelocal: any;
  showClearButton: boolean = false;

  @Input() showVehicleSearch: boolean = false;
  @Input() showVehicleSearchSlider: boolean = false;
  @ViewChild('searchbyvehicledialogref') searchbyvehicledialogref: ElementRef;

  constructor(
    private appConstants: AppConstants,
    private searchByVehicleService: SearchByVehicleService,
    private comm: CommunicationService,
    @Optional() private dialogRef: MatDialogRef<SearchByVehicleComponent>,
    private router: Router,
    private commonService: CommanpageService,
    private browser: BrowserService,
    @Optional() @Inject(DIALOG_DATA) public dialogData: any
  ) { }

  ngOnInit(): void {
    if (this.dialogData?.product_key) {
      this.mmyDropDownData.product_key = this.dialogData.product_key;
    }
    this.comm.vehicleSearch_without_category.subscribe(data => this.commonService.getVehicleFitmentViewSetting() == 'true' ? this.withoutCategorySearch = true : this.withoutCategorySearch = false);
    this.homeSettings = JSON.parse(this.browser.localStorage?.getItem('homeSettingData'));
    this.showFeaturedLogo = this.homeSettings[0].data.body.featured_logo;
    (async () => {
      await this.setMMYData();
    })();
    this.comm.clearvehicle.subscribe(data => {
      if (data === true) {
        this.clearVehicle();
        this.comm.clearvehicle.next(false);
      }
    });
  }

  async setMMYData() {
    const mmyData =
      JSON.parse(this.browser.localStorage?.getItem('vehiclesearchForm')) || null;
    const mmyCategoryData =
      JSON.parse(this.browser.localStorage?.getItem('mmysubCategoriesDropDownData')) || null;
    if (mmyCategoryData) {
      this.showCategory = true;
      this.mmysubCategoriesDropDownData = mmyCategoryData;
    }
    if (mmyData) {
      this.showSearchAgain = true;
      this.isMakeSelected = true;
      this.showClearButton = true;
      if (mmyData?.['select_make']) {
        this.getMakeData = this.searchByVehicleService.getMakeResponseData();
        this.selectedMakeKey = mmyData?.['select_make'] || '';
        this.makes = this.getMakeData?.makes;
        this.MakeData = this.getMakeData;
        this.initialData = this.makes;
        this.mmyDropDownData['select_make'] = mmyData?.['select_make'] || '';
        this.disableMake = false;
      }
      if (mmyData?.['select_model']) {
        this.getModelData = this.searchByVehicleService.getModelResponseData();
        this.selectedModelKey = mmyData?.['select_model'] || '';
        this.models = this.getModelData?.models;
        this.ModelData = this.getModelData;
        this.models = this.ModelData?.models || {};
        this.mmyDropDownData['select_model'] = mmyData?.['select_model'] || '';
        this.disableModel = false;
      }
      if (mmyData?.['select_year']) {
        this.getYearsData = this.searchByVehicleService.getYearResponseData();
        this.selectedYearKey = mmyData?.['select_year'] || '';
        this.years = this.getYearsData?.select_year;
        this.YearData = this.getYearsData;
        this.years = this.YearData?.select_year || {};
        this.mmyDropDownData['select_year'] = mmyData?.['select_year'] || '';
        this.disableYear = false;
        if (this.mmyDropDownData['select_year'] && mmyData?.['sub_model_1']) {
          this.showSubmodel1 = true;
        }
      }
      if (mmyData?.['sub_model_1']) {
        this.getSubModel1Data =
          this.searchByVehicleService.getSubmodels1ResponseData();
        this.selectedSubmodel1Key = mmyData?.['sub_model_1'] || '';
        this.submodels1 = this.getSubModel1Data?.sub_model_1;
        this.Submodels1Data = this.getSubModel1Data;
        this.submodels1 = this.Submodels1Data?.sub_model_1 || {};
        this.mmyDropDownData['sub_model_1'] = mmyData?.['sub_model_1'] || '';
        this.disableSubmodel1 = false;
        if (mmyData?.['sub_model_2']) {
          this.showSubmodel2 = true;
        }
      }
      if (mmyData?.['sub_model_2']) {
        this.getSubModel2Data =
          this.searchByVehicleService.getSubmodels2ResponseData();
        this.selectedSubmodel2Key = mmyData?.['sub_model_2'] || '';
        this.submodels2 = this.getSubModel2Data?.sub_model_2;
        this.Submodels2Data = this.getSubModel2Data;
        this.submodels2 = this.Submodels2Data?.sub_model_2 || {};
        this.mmyDropDownData['sub_model_2'] = mmyData?.['sub_model_2'] || '';
        this.disableSubmodel2 = false;
        if (mmyData?.['sub_model_3']) {
          this.showSubmodel3 = true;
        }
      }
      if (mmyData?.['sub_model_3']) {
        this.getSubModel3Data =
          this.searchByVehicleService.getSubmodels3ResponseData();
        this.selectedSubmodel3Key = mmyData?.['sub_model_3'] || '';
        this.submodels3 = this.getSubModel3Data?.sub_model_3;
        this.Submodels3Data = this.getSubModel3Data;
        this.submodels3 = this.Submodels3Data?.sub_model_3 || {};
        this.mmyDropDownData['sub_model_3'] = mmyData?.['sub_model_3'] || '';
        this.disableSubmodel3 = false;
      }
      this.mmyDataExists = false;
      this.changeDisablebtn(false);
    } else {
      this.showSearchAgain = false;
      this.showClearButton = false;
      this.mmyDataExists = false;
      if (this.mmyDropDownData.product_key) {
        this.fetchDropDownData();
      } else {
        this.getlocalMakedata();
      }
    }
  }

  async fetchDropDownData(): Promise<void> {
    try {
      const response = await this.searchByVehicleService
        .getDropDownDataSearchByVechicles(this.mmyDropDownData)
        .toPromise();
      if (response[this.firstObj]?.success === true) {
        this.dropDownData = response[this.firstObj]?.data || null;
        this.mmysubCategoriesDropDownData = [];
        if (this.dropDownData.makes) {
          if (!this.mmyDropDownData.product_key) {
            this.searchByVehicleService.setMakeResponseData(this.dropDownData);
          }
          this.MakeData = this.dropDownData;
          this.makes = this.MakeData?.makes || {};
          this.initialData = this.makes;
        } else if (this.dropDownData.models) {
          if (!this.mmyDropDownData.product_key) {
            this.searchByVehicleService.setModelResponseData(this.dropDownData);
          }
          this.ModelData = this.dropDownData;
          this.isMakeSelected = !!this.ModelData?.models;
          this.models = this.ModelData?.models || {};
        } else if (this.dropDownData.select_year) {
          if (!this.mmyDropDownData.product_key) {
            this.searchByVehicleService.setYearResponseData(this.dropDownData);
          }
          this.YearData = this.dropDownData;
          this.isModelSelected = !!this.YearData?.select_year;
          this.years = this.YearData?.select_year || {};
        } else if (this.dropDownData.sub_model_1) {
          this.showSubmodel1 = true;
          if (!this.mmyDropDownData.product_key) {
            this.searchByVehicleService.setSubmodels1ResponseData(this.dropDownData);
          }
          this.Submodels1Data = this.dropDownData;
          this.isYearSelected = !!this.Submodels1Data?.sub_model_1;
          this.submodels1 = this.Submodels1Data?.sub_model_1 || {};
        } else if (this.dropDownData.sub_model_2) {
          this.showSubmodel2 = true;
          if (!this.mmyDropDownData.product_key) {
            this.searchByVehicleService.setSubmodels2ResponseData(this.dropDownData);
          }
          this.Submodels2Data = this.dropDownData;
          this.isSubmodel1selected = !!this.Submodels2Data?.sub_model_2;
          this.submodels2 = this.Submodels2Data?.sub_model_2 || {};
        } else if (this.dropDownData.sub_model_3) {
          this.showSubmodel3 = true;
          if (!this.mmyDropDownData.product_key) {
            this.searchByVehicleService.setSubmodels3ResponseData(this.dropDownData);
          }
          this.Submodels3Data = this.dropDownData;
          this.isSubmodel2selected = !!this.Submodels3Data?.sub_model_3;
          this.submodels3 = this.Submodels3Data?.sub_model_3 || {};
        } else if (this.dropDownData.categories) {
          if (this.dialogData?.product_key || this.withoutCategorySearch) {
            return;
          }
          this.showCategory = true;
          if (this.selectedSubmodel3Key) {
            this.mmysubCategoriesDropDownData.push({
              id: 7,
              selected: '',
              data: this.dropDownData.categories,
            });
          } else if (this.selectedSubmodel2Key) {
            this.mmysubCategoriesDropDownData.push({
              id: 6,
              selected: '',
              data: this.dropDownData.categories,
            });
          } else if (this.selectedSubmodel1Key) {
            this.mmysubCategoriesDropDownData.push({
              id: 5,
              selected: '',
              data: this.dropDownData.categories,
            });
          } else if (this.selectedYearKey) {
            this.mmysubCategoriesDropDownData.push({
              id: 4,
              selected: '',
              data: this.dropDownData.categories,
            });
          }
        }
      } else {
        if (this.withoutCategorySearch) {
          this.onSearchVehicle();
        }
      }
    } catch (error) {
      console.error('Error fetching dropdown data:', error);
    }
  }

  async fetchSubCategoryData(dropdown: any, index: number) {
    this.mmysubCategoriesDropDownData = this.mmysubCategoriesDropDownData.slice(
      0,
      index + 1,
    );
    this.mmyDropDownData['category'] = dropdown.selected;
    if(this.mmysubCategoriesDropDownData?.length == 3){
      this.redirectToCategory();
      return;
    }
    this.searchByVehicleService
      .getDropDownDataSearchByVechicles(this.mmyDropDownData)
      .subscribe({
        next: (response: any) => {
          if (response?.[this.firstObj]?.success === true) {
            const categories = response[this.firstObj]?.data?.categories || [];
            if (categories?.length > 0) {
              this.mmysubCategoriesDropDownData.push({
                id: dropdown.id + 1,
                selected: '',
                data: categories,
              });
            }
          } else {
            this.redirectToCategory();
          }
        },
        error: (error: any) => {
          console.error('Dropdown fetch error', error);
        },
      });
  }

  disacardMMYData() {
    this.makes =
      this.models =
      this.years =
      this.submodels1 =
      this.submodels2 =
      this.submodels3 =
      {};
  }

  async onSelectMake() {
    this.mmyDropDownData['select_make'] = this.selectedMakeKey || '';
    this.mmyDropDownData['select_model'] = '';
    this.mmyDropDownData['select_year'] = '';
    this.mmyDropDownData['sub_model_1'] = '';
    this.mmyDropDownData['sub_model_2'] = '';
    this.mmyDropDownData['sub_model_3'] = '';
    this.selectedModelKey = '';
    this.selectedYearKey = '';
    this.selectedSubmodel1Key = '';
    this.selectedSubmodel2Key = '';
    this.selectedSubmodel3Key = '';
    this.models = this.years = {};
    this.submodels1 = {};
    this.submodels2 = {};
    this.submodels3 = {};
    this.disableMake = true;
    this.disableModel = true;
    this.disableYear = true;
    this.showSubmodel1 = false;
    this.showSubmodel2 = false;
    this.showSubmodel3 = false;
    this.isloading = true;
    this.mmysubCategoriesDropDownData = [];
    this.showCategory = false;
    if (this.selectedMakeKey != '') {
      await this.fetchDropDownData();
    } else {
      this.models = this.years = {};
      this.disableModel = true;
    }
    this.disableMake = false;
    if (!this.commonService.isEmpty(this.models)) {
      this.disableModel = false;
    }
    this.changeDisablebtn(true);
    this.isloading = false;
  }

  async onSelectModel() {
    this.mmyDropDownData['select_model'] = this.selectedModelKey || '';
    this.mmyDropDownData['select_year'] = '';
    this.mmyDropDownData['sub_model_1'] = '';
    this.mmyDropDownData['sub_model_2'] = '';
    this.mmyDropDownData['sub_model_3'] = '';
    this.selectedYearKey = '';
    this.selectedSubmodel1Key = '';
    this.selectedSubmodel2Key = '';
    this.selectedSubmodel3Key = '';
    this.years = {};
    this.submodels1 = {};
    this.submodels2 = {};
    this.submodels3 = {};
    this.disableMake = true;
    this.disableModel = true;
    this.disableYear = true;
    this.showSubmodel1 = false;
    this.showSubmodel2 = false;
    this.showSubmodel3 = false;
    this.isloading = true;
    this.mmysubCategoriesDropDownData = [];
    this.showCategory = false;
    await this.fetchDropDownData();
    this.disableMake = false;
    this.disableModel = false;
    if (!this.commonService.isEmpty(this.years)) {
      this.disableYear = false;
    }
    this.changeDisablebtn(true);
    this.isloading = false;
  }

  async onSelectYear() {
    this.mmyDropDownData['select_year'] = this.selectedYearKey || '';
    this.mmyDropDownData['sub_model_1'] = '';
    this.mmyDropDownData['sub_model_2'] = '';
    this.mmyDropDownData['sub_model_3'] = '';
    this.selectedSubmodel1Key = '';
    this.selectedSubmodel2Key = '';
    this.selectedSubmodel3Key = '';
    this.submodels1 = {};
    this.submodels2 = {};
    this.submodels3 = {};
    this.showSubmodel1 = false;
    this.showSubmodel2 = false;
    this.showSubmodel3 = false;
    if (
      this.mmyDropDownData.product_key &&
      this.mmyDropDownData['select_year']
    ) {
      this.changeDisablebtn(false);
    } else {
      this.changeDisablebtn(true);
    }
    this.isloading = true;
    this.mmysubCategoriesDropDownData = [];
    this.showCategory = false;
    await this.fetchDropDownData();
    this.disableMake = false;
    this.disableModel = false;
    this.disableYear = false;
    this.disableSubmodel1 = false;
    if (!this.commonService.isEmpty(this.submodels1)) {
      this.showSubmodel1 = true;
    }
    this.isloading = false;
  }

  async onSelectSubmodel1() {
    this.mmyDropDownData['sub_model_1'] = this.selectedSubmodel1Key || '';
    this.mmyDropDownData['sub_model_2'] = '';
    this.mmyDropDownData['sub_model_3'] = '';
    this.selectedSubmodel2Key = '';
    this.selectedSubmodel3Key = '';
    this.submodels2 = {};
    this.submodels3 = {};
    this.disableMake = true;
    this.disableModel = true;
    this.disableYear = true;
    this.disableSubmodel1 = true;
    this.disableSubmodel2 = false;
    this.disableSubmodel3 = false;
    this.showSubmodel2 = false;
    this.showSubmodel3 = false;
    this.isloading = true;
    this.mmysubCategoriesDropDownData = [];
    this.showCategory = false;
    await this.fetchDropDownData();
    this.disableMake = false;
    this.disableModel = false;
    this.disableYear = false;
    this.disableSubmodel1 = false;
    if (!this.commonService.isEmpty(this.submodels2)) {
      this.showSubmodel2 = true;
    }
    this.isloading = false;
  }

  async onSelectSubmodel2() {
    this.mmyDropDownData['sub_model_2'] = this.selectedSubmodel2Key || '';
    this.mmyDropDownData['sub_model_3'] = '';
    this.selectedSubmodel3Key = '';
    this.submodels3 = {};
    this.disableMake = true;
    this.disableModel = true;
    this.disableYear = true;
    this.disableSubmodel1 = true;
    this.disableSubmodel2 = true;
    this.disableSubmodel3 = false;
    this.showSubmodel3 = false;
    this.isloading = true;
    this.mmysubCategoriesDropDownData = [];
    this.showCategory = false;
    await this.fetchDropDownData();
    this.disableMake = false;
    this.disableModel = false;
    this.disableYear = false;
    this.disableSubmodel1 = false;
    this.disableSubmodel2 = false;
    if (!this.commonService.isEmpty(this.submodels3)) {
      this.showSubmodel3 = true;
    }
    this.isloading = false;
  }

  async onSelectSubmodel3() {
    this.mmyDropDownData['sub_model_3'] = this.selectedSubmodel3Key || '';
    this.disableMake = true;
    this.disableModel = true;
    this.disableYear = true;
    this.disableSubmodel1 = true;
    this.disableSubmodel2 = true;
    this.disableSubmodel3 = true;
    this.showSubmodel3 = true;
    this.changeDisablebtn(true);
    this.isloading = true;
    this.mmysubCategoriesDropDownData = [];
    this.showCategory = false;
    await this.fetchDropDownData();
    this.disableMake = false;
    this.disableModel = false;
    this.disableYear = false;
    this.disableSubmodel1 = false;
    this.disableSubmodel2 = false;
    this.isloading = false;
  }

changeVehicleName(action = 'set') {
  if (action === 'set') {
    let name = String(this.years[this.selectedYearKey] || '');
    if (this.makes?.[this.selectedMakeKey]) {
      name = name
        ? `${name} ${this.makes[this.selectedMakeKey]}`
        : this.makes[this.selectedMakeKey];
    }
    if (this.models?.[this.selectedModelKey]) {
      name = name
        ? `${name} ${this.models[this.selectedModelKey]}`
        : this.models[this.selectedModelKey];
    }
    if (this.submodels1?.[this.selectedSubmodel1Key] && this.chTheme3) {
      name = name
        ? `${name} ${this.submodels1[this.selectedSubmodel1Key]}`
        : this.submodels1[this.selectedSubmodel1Key];
    }
    this.vehicleName = name;
    this.comm.setVehicleName(name);
  } else {
    this.vehicleName = '';
    this.comm.setVehicleName('');
  }
}

  onSearchVehicle() {
    if (this.dialogData?.product_key) {
      this.comm.setVehicleForm(this.mmyDropDownData);
      this.changeVehicleName();
      if (this.dialogRef) this.dialogRef.close(SearchByVehicleComponent);
    } else if (this.withoutCategorySearch && !this.dialogData?.product_key) {
      this.comm.setVehicleForm(this.mmyDropDownData);
      this.changeVehicleName();
      this.router.navigate(['/vehicle-search']);
      if (this.dialogRef) this.dialogRef.close(SearchByVehicleComponent);
    } else {
      this.redirectToCategory();
    }
  }

  redirectToCategory() {
    this.browser.localStorage?.setItem(
      'mmysubCategoriesDropDownData',
      JSON.stringify(this.mmysubCategoriesDropDownData),
    );
    this.comm.setVehicleForm(this.mmyDropDownData);
    const lastElement =
      this.mmysubCategoriesDropDownData[
      this.mmysubCategoriesDropDownData?.length - 1
      ];
    lastElement.data.map((element: any) => {
      if (Number(lastElement.selected) == element.category_key) {
        this.lastSubCategory = element;
      }
    });
    this.changeVehicleName();
    const category_name = this.lastSubCategory.name
      .toLowerCase()
      .replace(/[^a-zA-Z0-9\s]/g, '')
      .replace(/\s+/g, '-');
    const currentUrl = this.router.url;
    if (
      currentUrl == `/${category_name}/c${this.lastSubCategory.category_key}`
    ) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.commonService.categoryRedirection(
          this.lastSubCategory.name,
          this.lastSubCategory.category_key,
        );
      });
    } else {
      this.commonService.categoryRedirection(
        this.lastSubCategory.name,
        this.lastSubCategory.category_key,
      );
    }
    if (this.dialogRef) this.dialogRef.close(SearchByVehicleComponent);
  }

  clickOutsideBox(isClickedOutside: boolean) {
    if (isClickedOutside) {
      if (!this.firstClickedOutside) {
        this.dialogRef.close(SearchByVehicleComponent);
      }
      this.firstClickedOutside = false;
    }
  }

  yearsDesc = (
    a: KeyValue<string, string>,
    b: KeyValue<string, string>,
  ): number => {
    return +a.key > +b.key ? -1 : +b.key > +a.key ? 1 : 0;
  };

  isSearchDisabled() {
    return this.disableSearchAgain;
  }

  changeDisablebtn(value: boolean) {
    if (this.withoutCategorySearch)
      this.disableSearchAgain = false;
    else
      this.disableSearchAgain = value;
  }

  clearVehicle() {
    this.disacardMMYData();
    this.disableModel = true;
    this.disableYear = true;
    this.showSubmodel1 = false;
    this.showSubmodel2 = false;
    this.showSubmodel3 = false;
    this.mmysubCategoriesDropDownData = [];
    this.showCategory = false;
    this.browser.localStorage?.removeItem('mmysubCategoriesDropDownData');
    this.makes = this.initialData;
    this.selectedMakeKey = this.selectedModelKey = this.selectedYearKey = '';
    this.searchByVehicleService.clearVehicleSearch();
    if (this.dialogRef) this.dialogRef.close(SearchByVehicleComponent);
  }

  getlocalMakedata() {
    if (this.mmyDropDownData.product_key) {
      this.fetchDropDownData();
      return;
    }
    this.getMakeData = this.searchByVehicleService.getMakeResponseData();
    if (this.getMakeData?.makes) {
      this.makes = this.getMakeData?.makes;
      this.MakeData = this.getMakeData;
      this.initialData = this.makes;
      this.disableMake = false;
    } else {
      this.fetchDropDownData();
    }
  }
}